import React, { useContext } from 'react';
import { Spin } from 'antd';
import GeneralContext from '../../context/GeneralContext/GeneralContext';

const Loader = () => {
  const { show_loading } = useContext(GeneralContext);

  if (!show_loading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Loader;



